<template>
  <div class="BIVisualization">
    <div class="myimg">
      <img src="../../../public/static/image/elTree/data.png" alt="">
    </div>
    <div class="mymap">
      <transformerMap></transformerMap>
    </div>

  </div>
</template>

<script>
  import transformerMap from '@/page/projectDingZhi/huapu/transformerMap.vue'
  export default {
    components: {
      transformerMap,
    },
    data () {
      return {

      };
    },

    mounted () {

    },

    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  .BIVisualization {
    padding: 0px !important;
    position: relative;

    .myimg {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        // transform: scale(1.2);
        width: 100%;
        height: 100%;
      }
    }

    .mymap {
      width: 58%;
      height: 55%;
      position: absolute;
      top: 11.5%;
      left: 50.5%;
      transform: translateX(-50%);
    }
  }
</style>